import { AsyncState, HttpResult, loadingAsyncState, Unit } from "widgets-for-react";
import { ActiveSubscription } from "../subscriptionState";

export const terminateActiveSubscription = (subscription: ActiveSubscription): AsyncState<Unit> =>
    loadingAsyncState(
      async () => {
        let headers = new Headers()
        headers.append('content-type', 'text/plain')
        // headers.append('content-type', 'application/json')
        // headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)
  
        let res = await fetch(`/api/v1/Checkout/TerminateActiveSubscription?activeSubscriptionId=${subscription.Id}`, {
          method: 'post', credentials: 'include', headers: headers,
        })
        if (!res.ok) throw Error(res.statusText)
        let result: HttpResult<Unit> = { kind: "result", value: {}, status: 200 }
        return result
      })